




import { Vue, Component, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ICustomer, IProject, IMarkers } from '@/interfaces/data';
import store from '@/store';
import {
  SET_OVERLAY_DISPLAY,
  COPY_MARKERS_TO_TEMPMARKERS,
  SET_FILTERING_STATE_TO_DEFAULT,
  SET_FILTERING_ELEMENT_DISABLED,
  CHANGE_SLIDER_MODEL_VALUE,
  CHANGE_RADIO_GROUP_TEXT,
  CLEAR_TEMPMARKERS
} from '@/store/constants/mutation-types';

@Component
export default class AdminTreeView extends Vue {
  public $auth!: {
    token: string;
    isAuthenticated: boolean;
    isAdmin: boolean;
  };

  private treeViewItems = [];
  private treeModelValue = [];
  private treeViewModel = [];
  private treeViewModelCopy = [];

  @(namespace('ProjectModule').State('projects')) private projects!: IProject[];

  @(namespace('LocationModule').Mutation('deleteLocation'))
  private deleteLocation!: (projectId) => null;

  @(namespace('LocationModule').Action('requestAllLocationsForProject'))
  private requestAllLocationsForProject!: ({ token, projectId }) => Promise<{}>;

  @(namespace('LocationModule').Action('requestAllLocationsForCustomer'))
  private requestAllLocationsForCustomer!: ({
    token,
    customerId
  }) => Promise<{}>;

  @(namespace('CustomerModule').State('customers'))
  private customers!: ICustomer[];

  @(namespace('LocationModule').State('tempMarkers'))
  private tempMarkers!: IMarkers[];

  @(namespace('ProjectModule').Action('getProjects'))
  private getProjects!: (token) => Promise<{}>;

  @(namespace('CustomerModule').Action('getCustomers'))
  private getCustomers!: (token) => Promise<{}>;

  @(namespace('OverLayModule').State('overlayEnable'))
  private overlay;

  @(namespace('MarkersFilteringModule').State('radioGroup'))
  private radioGroup;

  @(namespace('MarkersFilteringModule').State('filterElementDisabled'))
  private filterElementDisabled;

  private onTreeModelPropertyChanged(items) {
    // if the tree view item is checked the array length will
    // be bigger than the previous length
    store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, true);
    if (this.treeViewModel.length > this.treeViewModelCopy.length) {
      items.map(async item => {
        if (!this.treeViewModelCopy.includes(item)) {
          if (item.startsWith('Project')) {
            await store.dispatch(
              'LocationModule/requestAllLocationsForProject',
              {
                token: this.$auth.token,
                projectId: item.slice(8)
              }
            );
            store.commit(`LocationModule/${COPY_MARKERS_TO_TEMPMARKERS}`);
          }
          store.commit(
            `MarkersFilteringModule/${SET_FILTERING_ELEMENT_DISABLED}`,
            false
          );
          store.commit(
            `MarkersFilteringModule/${CHANGE_RADIO_GROUP_TEXT}`,
            'all'
          );
          store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, false);
        }
      });
    } else {
      this.treeViewModelCopy.map(item => {
        if (!this.treeViewModel.includes(item)) {
          this.deleteLocation(parseInt(item.slice(8), 10));
        }
        if (this.treeViewModel.length === 0) {
          store.commit(
            `MarkersFilteringModule/${SET_FILTERING_ELEMENT_DISABLED}`,
            true
          );
          store.commit(
            `MarkersFilteringModule/${CHANGE_SLIDER_MODEL_VALUE}`,
            0
          );
          store.commit(`MarkersFilteringModule/${CHANGE_RADIO_GROUP_TEXT}`, '');
        }
        store.commit(`OverLayModule/${SET_OVERLAY_DISPLAY}`, false);
      });
    }
    this.treeViewModelCopy = this.treeViewModel.slice();
    store.commit(`MarkersFilteringModule/${CHANGE_SLIDER_MODEL_VALUE}`, 0);
    store.commit(`MarkersFilteringModule/${CHANGE_RADIO_GROUP_TEXT}`, '');
  }

  private async created() {
    // create load-children
    store.commit(`LocationModule/${CLEAR_TEMPMARKERS}`);
    await this.getCustomers(this.$auth.token);
    await this.getProjects(this.$auth.token);

    this.customers.map(customer => {
      const treeViewItem = {
        id: `Customer ${customer.id}`,
        name: customer.name,
        children: []
      };

      this.projects.map(project => {
        if (project.customerId === customer.id) {
          treeViewItem.children.push({
            id: `Project ${project.id}`,
            name: project.name,
            customerId: customer.id
          });
        }
      });
      this.treeViewItems.push(treeViewItem);
    });
  }
}
